import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import {
  stylesForDefaultState,
  stylesForFocusState,
  stylesForHoverState,
} from '../../../_internal/theme/stylesFor';

const Background = styled('div')`
  display: inline-flex;
  flex: 1;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  transition: background-color 150ms linear, border-color 150ms linear;

  ${stylesForDefaultState('switch')}

  &:hover {
    ${stylesForHoverState('switch')}
  }

  &:focus {
    outline: 0;
    ${stylesForFocusState('switch')}
  }
`;

Background.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Background;
